<template>
  <footer>
    <div class="foot_content">
      <div class="qrcode">
        <img :src="$baseUrl + '/upload-router-api/personPhoto/2024/11/13/1731462829571672295.png'" width=" 192px"
          height="45px" alt />
        <div class="div-log">
          <div class="log">
            <img src="/static/images/home/tinified/qrcodeshebei.png" width="88px" height="88px" alt />
            <div style="color: #9393b5; margin-top: 10px; font-size: 14px">
              玉鸿图大数据
            </div>
          </div>
          <div class="log">
            <img src="/static/images/home/tinified/shuziyun.jpg" width="88px" height="88px" alt />
            <div style="color: #9393b5; margin-top: 10px; font-size: 14px">
              玉鸿图数字云
            </div>
          </div>
        </div>
      </div>
      <div class="menu">
        <div class="foot_title">关于我们</div>
        <div class="menu_child" @click="route(0, 0)" style="margin-top: 20px">
          玉鸿图介绍
        </div>
        <div class="menu_child" @click="route(0, 1)" style="margin-top: 10px">
          荣誉资质
        </div>
        <div class="menu_child" @click="route(0, 2)" style="margin-top: 10px">
          联系我们
        </div>
      </div>

      <div class="menu">
        <div class="foot_title">解决方案</div>
        <div class="menu_child" @click="route(1, 0)" style="margin-top: 20px">
          慢病管理解决方案
        </div>
        <div class="menu_child" @click="route(1, 1)" style="margin-top: 10px">
          动态心电监测解决方案
        </div>
        <div class="menu_child" @click="route(1, 2)" style="margin-top: 10px">
          医疗高值耗材解决方案
        </div>
      </div>
      <div class="menu">
        <div class="foot_title">新闻中心</div>
        <div class="menu_child" @click="route(2, 0)" style="margin-top: 20px">
          产品动态
        </div>
        <div class="menu_child" @click="route(2, 0)" style="margin-top: 10px">
          企业动态
        </div>
        <div class="menu_child" @click="route(2, 0)" style="margin-top: 10px">
          行业动态
        </div>
        <div class="menu_child" @click="route(2, 0)" style="margin-top: 10px">
          国家政策
        </div>
      </div>
      <div class="menu">
        <div class="foot_title">服务支持</div>
        <div class="menu_child" @click="route(3, 0)" style="margin-top: 20px">
          下载心电系统
        </div>
        <div class="menu_child" @click="route(3, 0)" style="margin-top: 10px">
          进入心电小程序
        </div>
        <div class="menu_child" @click="route(3, 0)" style="margin-top: 10px">
          产品使用说明
        </div>
      </div>
      <!-- <div class="menu">
        <div class="foot_title">后台登录</div>
        <div class="menu_child" @click="route(4, 0)" style="margin-top: 20px">
          数字健康云
        </div>
        <div class="menu_child" @click="route(4, 0)" style="margin-top: 10px">
          数字慢病监管系统
        </div>
      </div> -->
    </div>
    <!--    备案信息-->
    <div class="beiAn">
      <img src="//img.alicdn.com/tfs/TB1..50QpXXXXX7XpXXXXXXXXXX-40-40.png" />
      <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=36070202000595">赣公网安备
        36070202000595号</a>
      &nbsp;&nbsp;
      <a target="_blank" href="https://beian.miit.gov.cn">赣ICP备2022004592号-1</a>
    </div>
  </footer>
</template>
<script>
import { I } from "caniuse-lite/data/agents";

export default {
  data() {
    return {
      path: ["/Abouts", "/Solutions", "/News", "/ServiceSupport"],
    };
  },
  methods: {
    route(index, current_type) {
      switch (index) {
        case 0:
        case 1:
          this.$router.push({
            path: this.path[index],
            query: { current_type: current_type },
          });
          break;
        case 2:
        case 3:
          this.$router.push({
            path: this.path[index],
          });
          break;
        case 4:
          let path = "";
          if (current_type == 0) {
            path = "https://jxhnznsb.com/admin-static/#/";
          } else {
            path =
              "https://jxhnznsb.com/supervision-static/#/Login?redirect=%2Fhome";
          }
          window.open(path, "_blank"); // 在新窗口打开外链接
          break;

        default:
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.menu_child {
  cursor: pointer;
  text-decoration: none;
  color: #9393b5;
  font-size: 14px;
}

.beiAn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  text-align: center;
  line-height: 50px;
  margin-top: 10px;
}

.beiAn img {
  width: 18px;
  margin-right: 10px;
}

.beiAn a {
  font-size: smaller;
  color: #43436d;
  text-decoration: none;
}

.menu_child:hover {
  color: #ff6a00;
}

footer {
  width: 100%;
  height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  // background-color: #0b0b3b;
}

.foot_content {
  display: flex;
  width: 100%;
  justify-content: center;
  gap: 150px;
  flex-direction: row;
  padding-top: 40px;

  .div-log {
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    gap: 10px;

    .log {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
    }
  }

  .menu {
    display: flex;
    height: 100px;
    margin-top: 14px;
    flex-direction: column;

    .foot_title {
      color: white;
      font-size: 16px;
    }
  }
}

footer::after {
  content: "";
  width: 140%;
  height: 384px;
  position: absolute;
  left: -20%;
  bottom: 1;
  z-index: -1;
  border-radius: 50% 50% 0 0;
  background: #0b0b3b;
}
</style>



// WEBPACK FOOTER //
// src/views/Layout/HomeFooter.vue